module.exports = __webpack_public_path__ + "img/Dwayne.a98128cc.png";